import {
  IBucketV2DeploymentRequest,
  IDeploymentJobCreateRequest,
} from "api/entities/deployment-job";
import { DataService } from "./data-service";

class JobService extends DataService {
  constructor() {
    super("job", 2);
  }

  createCluster(request: IDeploymentJobCreateRequest) {
    return this.api.post<number>("cluster", request);
  }

  createLkeBzs(clusterId: string, bucketName: string) {
    return this.api.post<boolean>("lke/bzs", {
      bucketName,
      clusterId,
    });
  }

  createBzs(request: IBucketV2DeploymentRequest): Promise<string> {
    return this.api.post<string>("bzs", request);
  }
  
  deleteBzs(id: string): Promise<void> {
    return this.api.delete<void>(`bzs/${id}`);
  }
}

export const jobService = new JobService();
